const initialState = {
  noticeResult: {},
};

// 获取公告内容
export default function getNoticeCon(state = initialState, action) {
  switch (action.type) {
  case 'NOTICE_CONTENT':
    return { ...state, noticeResult: action.payload };
  default:
    return state;
  }
}